import axios from "axios";
import router from "@/router";
import Element from "element-ui"
import { Message } from "element-ui";

/**
 * 根据错误码获取提示消息
 */
function getMessageByCode(code) {
    const messages = {
        11006: '用户不存在，请重新登录',
        401: '登录已过期，请重新登录',
        403: '无权访问，请重新登录',
    };
    return messages[code] || `系统错误 (代码：${code})`;
}

axios.defaults.baseURL = window.baseURL
// axios.defaults.baseURL = "http://121.36.244.209:8848"

// axios.defaults.baseURL = "http://localhost:8891"



const request = axios.create({
    timeout: 180000,
    // headers: {
    //     'Content-Type': "application/json; charset=utf-8"
    // }
})

request.interceptors.request.use(config => {
    config.headers['Authorization'] = sessionStorage.getItem("token");
    return config;
})

request.interceptors.response.use(response => {
        let res = response.data;
        
        // 成功情况，直接返回响应
        if (res.code === 0 || res.code === 200) {
            return response;
        }
        
        // 检查是否需要跳转到登录页的错误码
        const needLoginCodes = [11006, 401, 403];
        const codeStr = res.code ? res.code.toString() : '';
        
        // 如果是需要登录的错误码（11006、401、403 或 40 开头）
        if (needLoginCodes.includes(Number(res.code)) || codeStr.startsWith('40')) {
            // 清除本地存储
            try {
                localStorage.clear();
                sessionStorage.clear();
            } catch (e) {
                console.error('清除本地存储失败:', e);
            }
            
            // 显示错误提示
            const errorMsg = res.msg || getMessageByCode(res.code);
            Element.Message.error(errorMsg);
            
            // 延迟跳转到登录页
            setTimeout(() => {
                router.replace({
                    path: '/login',
                    query: {
                        redirect: window.location.pathname + window.location.search
                    }
                });
            }, 500);
            
            return Promise.reject({code: res.code, message: errorMsg, type: 'auth'});
        }
        
        // 只拦截 40 开头的错误码用于业务层处理
        if (res.code && res.code.toString().startsWith('40')) {
            return Promise.reject({code: res.code, message: res.msg, type: 'business'});
        }
        
        // 其他错误码直接返回，不拦截，让业务代码自行处理
        return response;
    }, error => {
        console.log("network error = ", error);
        
        // 如果有响应，说明服务器有返回，这通常是HTTP状态码错误（如404、500等）
        if (error.response) {
            // HTTP状态码错误，不弹窗，让业务代码处理
            const errorInfo = {
                message: error.response.data?.msg || `HTTP ${error.response.status} 错误`,
                status: error.response.status,
                type: 'http',
                originalError: error
            };
            
            // 401状态码特殊处理：跳转到登录页
            if (error.response.status === 401) {
                router.push('/login');
            }
            
            return Promise.reject(errorInfo);
        }
        
        // 如果没有响应，说明是真正的网络请求失败（如网络断开、超时等）
        // 只有这种情况才弹窗提示
        const isNetworkError = !error.response && (
            error.code === 'NETWORK_ERROR' || 
            error.code === 'ECONNABORTED' || 
            error.message.includes('timeout') ||
            error.message.includes('Network Error')
        );
        
        if (isNetworkError) {
            // Element.Message.error('服务连接失败，请检查网络设置', {duration: 3000});
        }
        
        // 返回包含更多信息的错误对象
        // const errorInfo = {
        //     message: error.message || '网络请求失败',
        //     type: 'network',
        //     originalError: error
        // };
        // return Promise.reject(errorInfo);
    }
)

export default request
